import Layout from 'antd/es/layout/layout'
import * as React from 'react'
import ReactDOM from 'react-dom/client'

import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import Login from './Admin/Login'
import HomePage from './Public/HomePage/HomePage'
import ProPage from './Public/ProPage/ProPage'
import { GlobalContextProvider } from './Admin/GlobalContext'
import BoxesPage from './Admin/BoxesPage/BoxesPage'
import MenuLayout from './Admin/Menu/MenuLayout'
/* eslint-disable no-unused-vars */ // keep the following line
import i18n from './locales/i18n'
/* eslint-enable no-unused-vars */
import { ConfigProvider } from 'antd'
import frFR from 'antd/locale/fr_FR'
import BoxMenuLayout from './Admin/BoxPage/BoxMenuLayout'
import BoxCalendarPage from './Admin/BoxPage/BoxCalendarPage/BoxCalendarPage'
import BoxInfoPage from './Admin/BoxPage/BoxInfoPage'
import { BoxContextProvider } from './Admin/BoxPage/BoxContext'
import 'dayjs/locale/fr'
import dayjs from 'dayjs'
import i18next from 'i18next'
import BoxListPage from './Public/BoxList/BoxListPage'
import BoxPage from './Public/BoxPage/BoxPage'
import CreateAppointmentPage from './Public/Appointment/CreateAppointmentPage'
import AppointmentPage from './Public/Appointment/AppointmentPage'
import AppointmentsPage from './Admin/AppointmentsPage/AppointmentsPage'
import AdminAppointment from './Admin/AdminAppointment/AdminAppointment'
import OwnersPage from './Admin/OwnersPage/OwnersPage'
import OwnerPage from './Admin/OwnerPage/OwnerPage'
import { Color } from './Common/Color'
import UsersPage from './Admin/UsersPage/UsersPage'
import UserPage from './Admin/UserPage/UserPage'
import UpdatePassword from './Admin/UpdatePassword'
import { SpecialistContextProvider } from './Public/Specialist/SpecialistContext'
import BoxSpecialistAppointmentList from './Public/BoxPage/BoxSpecialistAppointmentList'
import CreateSpecialistAppointmentPage from './Public/Specialist/CreateSpecialistAppointmentPage'
import EventsPage from './Admin/EventsPage/EventsPage'
import ConfirmAppointmentForm from './Public/Appointment/ConfirmAppointmentForm'
import BoxLogsPage from './Admin/BoxPage/BoxLogsPage'
import ErrorPage from './Public/ErrorPage/ErrorPage'
import Changelog from './Admin/ChangelogPage/Changelog'
import BoxSetupCalendarPage from './Admin/BoxPage/BoxSetupCalendarPage'
import IntervenersPage from './Admin/IntervenersPage/IntervenersPage'
import GepetosPage from './Admin/GepetosPage/GepetosPage'
import GepetoPage from './Admin/GepetoPage/GepetoPage'
import Intervener from './Admin/IntervenerPage/Intervener'
import BoxSpecialistsPage from './Admin/BoxPage/BoxSpecialistsPage'
import TeleconsultingCompaniesPage from './Admin/TeleconsultingCompaniesPage/TeleconsultingCompaniesPage'
import TeleconsultingCompanyPage from './Admin/TeleconsultingCompanyPage/TeleconsultingCompanyPage'
import TagsPage from './Admin/TagsPage/TagsPage'
import MaintenancePage from './Public/MaintenancePage/MaintenancePage'

import { PublicContextProvider } from './Public/PublicContext'
import CompleteLayout from './Public/Layouts/DefaultLayout/CompleteLayout'
import HeaderLayout from './Public/Layouts/DefaultLayout/HeaderLayout'
import SiderLayout from './Public/Layouts/DefaultLayout/SiderLayout'
import CGUPage from './Public/CGUPage/CGUPage'
import BoxStatistics from './Admin/Statistics/BoxStatistics'
import BoxClusterPage from './Admin/BoxPage/BoxClusterPage'
import ChatsPage from './Admin/ChatsPage/ChatsPage'
import AppointmentsHistoryPage from './Admin/AppointmentsPage/AppointmentsHistoryPage'
import { LoginContextProvider } from './Admin/LoginContext'

dayjs.locale('fr')
i18next.init({
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b']
  }
})

const router = createBrowserRouter([
  {
    element: <PublicContextProvider />,
    children: [
      {
        element: <CompleteLayout />,
        children: [
          { path: '/', element: <HomePage /> },
          { path: '/maintenance', element: <MaintenancePage /> },
          { path: '/403', element: <ErrorPage error="403" /> },
          { path: '/404', element: <ErrorPage error="404" /> },
          { path: '/422', element: <ErrorPage error="422" /> },
          { path: '/500', element: <ErrorPage error="500" /> },
          { path: '/collectivite', element: <ProPage /> },
          { path: '*', element: <ErrorPage error="404" /> }
        ]
      },
      {
        element: <HeaderLayout />,
        children: [
          { path: '/cgu', element: <CGUPage /> },
          { path: '/results', element: <BoxListPage /> }
        ]
      },
      {
        element: <SiderLayout />,
        children: [
          {
            path: '/box/:boxId',
            children: [
              { path: '', element: <BoxPage /> },
              { path: 'appointment_create', element: <CreateAppointmentPage /> },
              { path: 'appointment_create/:appointmentDate', element: <CreateAppointmentPage /> },
              { path: 'confirm_appointment/:appointmentId', element: <ConfirmAppointmentForm /> },
              {
                element: <SpecialistContextProvider />,
                children: [
                  { path: 'specialist_appointment_create', element: <CreateSpecialistAppointmentPage /> },
                  { path: 'specialist', element: <BoxSpecialistAppointmentList /> }
                ]
              }
            ]
          },
          { path: '/appointments/:appointmentId', element: <AppointmentPage /> }
        ]
      }
    ]
  },
  {
    path: '/admin',
    children: [
      {
        element: <LoginContextProvider />,
        children: [
          { path: '', element: <Navigate to="/admin/appointments_dashboard" /> },
          { path: 'login', element: <Login /> },
          { path: 'password', element: <UpdatePassword /> },
          {
            element: <GlobalContextProvider />,
            children: [
              {
                element: <MenuLayout />,
                children: [
                  { path: 'boxes', element: <BoxesPage /> },
                  {
                    element: <BoxContextProvider />,
                    children: [
                      {
                        path: 'boxes/:id',
                        element: <BoxMenuLayout />,
                        children: [
                          { path: 'calendar', element: <BoxCalendarPage /> },
                          { path: 'info', element: <BoxInfoPage /> },
                          { path: 'opening', element: <BoxSetupCalendarPage /> },
                          { path: 'logs', element: <BoxLogsPage /> },
                          { path: 'specialists', element: <BoxSpecialistsPage /> },
                          { path: 'cluster', element: <BoxClusterPage /> }
                        ]
                      }
                    ]
                  },
                  { path: 'changelog', element: <Changelog /> },
                  { path: 'chats', element: <ChatsPage /> },
                  { path: 'events', element: <EventsPage /> },
                  { path: 'events/:id', element: <EventsPage /> },
                  { path: 'gepetos', element: <GepetosPage /> },
                  { path: 'gepetos/:id', element: <GepetoPage /> },
                  { path: 'interveners', element: <IntervenersPage /> },
                  { path: 'interveners/:id', element: <Intervener /> },
                  { path: 'owners', element: <OwnersPage /> },
                  { path: 'owners/:id', element: <OwnerPage /> },
                  { path: 'appointments_dashboard', element: <AppointmentsPage /> },
                  { path: 'appointments_history', element: <AppointmentsHistoryPage /> },
                  { path: 'appointments/:id', element: <AdminAppointment /> },
                  { path: 'statistics', element: <BoxStatistics /> },
                  { path: 'tags', element: <TagsPage /> },
                  { path: 'teleconsulting_companies', element: <TeleconsultingCompaniesPage /> },
                  { path: 'teleconsulting_companies/:id', element: <TeleconsultingCompanyPage /> },
                  { path: 'users', element: <UsersPage /> },
                  { path: 'users/:id', element: <UserPage /> }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
], {
  future: {
    v7_relativeSplatPath: true
  }
})

const queryClient = new QueryClient()

const App = () => {
  return (
    <Layout style={{ height: '100vh' }}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Layout>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  const rootEl = document.getElementById('root')
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <ConfigProvider
        locale={frFR}
        theme={{
          hashed: false,
          token: {
            fontFamily: 'custom-font',
            colorPrimary: Color.primary,
            borderRadius: '30',
            colorInfo: '#FF4438'
          },
          components: {
            Button: { borderRadius: '16px', defaultHoverBg: Color.primary },
            Input: { borderRadius: '10px', borderRadiusSM: '10px' },
            InputNumber: { borderRadius: '10px', borderRadiusSM: '10px' },
            DatePicker: { borderRadius: '10px', borderRadiusSM: '10px' },
            Select: { borderRadius: '10px', borderRadiusSM: '10px' },
            Tab: {}
          }
        }}
      >
        <App />
      </ConfigProvider>
    </React.StrictMode >
  )
})
